// =====================================================================
// accidents.js — règles pures du registre des accidents, côté écran
// =====================================================================

/**
 * Ce qu'il manque encore pour pouvoir clôturer une fiche (vide = clôturable).
 * Miroir de `manquesAvantCloture` (backend/src/services/safety-incident.service.js) :
 * une fiche close arrête tous les rappels, on ne ferme pas une obligation ouverte.
 */
export function manquesCloture(inc) {
  const manque = [];
  if (!inc) return manque;
  if (inc.insurerDeadline && !inc.insurerDeclaredAt) manque.push('la déclaration à l’assureur');
  if (inc.graveReportDue && !inc.graveReportSentAt) manque.push('le rapport circonstancié');
  if (inc.severity === 'TRES_GRAVE' && !inc.graveNotifiedAt) manque.push('la notification immédiate à l’inspection');
  return manque;
}
